import React from 'react'

import AuthProvider2 from './AuthProvider2'

export default function ({ children }) {
  return <AuthProvider2>{children}</AuthProvider2>
}
